import * as v from '@badrap/valita'
import { api } from 'src/api'

export const getOrganizations = (params: {
  organization: string
  username: string
}) =>
  api({
    schema: v
      .object({
        result: v.literal('OK'),
        organizations: v.array(v.string()),
      })
      .chain((data) => v.ok(data.organizations)),
    method: 'POST',
    url: '/getorganizations',
    body: params,
    withAuth: true,
  })

// TODO: could use setupOrgSchema.extend({...})
export const validOrgSchema = v.object({
  activityTimeout: v
    .union(v.string(), v.number())
    .chain((data) => v.ok(Number(data))),
  billing: v.union(
    v.literal('free'),
    v.literal('billable'),
    v.literal('trial'),
    v.literal('custom'),
    v.literal('contract'),
    v.literal('contract_trial'),
  ),
  createtimestamp: v
    .union(v.string(), v.number())
    .chain((data) => v.ok(Number(data))),
  edittimestamp: v
    .union(v.string(), v.number())
    .chain((data) => v.ok(Number(data))),
  organization: v.string(), // idealsystems3
  aws_connect_type: v.union(
    v.literal('SAML'),
    v.literal('CCP'),
    v.literal('SSO'),
    v.literal('SALESFORCE'),
  ),
  application: v.object({
    debug_timeout: v
      .union(v.string(), v.number())
      .default(8)
      .chain((data) => v.ok(Number(data))),
    country_code: v.string().optional(), // BE
    androidurl: v.string(), // http://xxxx
    autoreadyafterlogin: v.string(), // false
    chatregion: v.string(), // eu-central-1
    crm_button_enabled: v.boolean().default(false),
    crm_button_key: v.string().default('CRM_URL'),
    enabled: v.string(), // true
    iosurl: v.string(), // https://apps.apple.com/us/app/mobileoffice-for-genesys/id1467327762
    kvps: v.record(v.string()), // { "kvp3": "Language", "kvp1": "First Name", "kvp2": "Last Name" }
    kvpsandroidsplash: v.object({
      kvp1: v.string(),
      kvp2: v.string(),
    }), // { "kvp1": "First Name", "kvp2": "Last Name" }
    kvpsiossplash: v.object({
      kvp1: v.string(),
      kvp2: v.string(),
    }), // { "kvp1": "First Name", "kvp2": "Last Name" }
    logoutonlogin: v.string(), // false
    minversion: v.string(), // 1.0.0
    options: v.record(v.string()), // { "option1": "test" }
    sf_button_enabled: v.boolean().default(false),
    sf_button_key: v.string().default('SALESFORCE1_URL'),
    sf_client_id: v.string().default(''),
    sf_client_secret: v.string().default(''),
    sf_endpoint: v.string().default(''),
    sf_url: v.string().default(''),
    sf_username: v.string().default(''),
    sf_password: v.string().default(''),
    salesforceEnabled: v.boolean().default(false),
    disabled_auto_markdone: v.boolean().default(true),
  }),
  code: v.string(), // id_1234
  failedAgentConnectTimer: v.string(), // 20000
  iam_organization_admin_accessKey: v.string().default(''), // AKIAVTMOYFFUASZVO7ES
  iam_organization_policy_arn: v.string().default(''), // arn:aws:iam::385235822952:policy/mo_connect_policy
  iam_organization_usergroup: v.string().default(''), // mobileconnect
  aws_connect_saml_url: v.string(), // https://idealsaml.my.connect.aws
  organization_connect_instance_id: v.string().optional(), //
  organization_connect_account_id: v.string().optional(), //
  organization_connect_arn: v.string().default(''), //
  setupStep: v.union(
    v.literal('finished'),
    v.literal('salesforce-configuration'),
    v.literal('setup'),
  ), // "finished" | "setup"
  sso: v
    .object({
      loginUrl: v.string(),
      principalArn: v.string(),
      roleArn: v.string(),
      region: v.string(),
      type: v.string().optional(),
    })
    .optional(),
})

export const getOrganization = async (params: {
  organization: string
  username: string
}) =>
  api({
    schema: v
      .object({
        result: v.literal('OK'),
        organization: validOrgSchema,
      })
      .chain((data) => v.ok(data.organization)),
    method: 'POST',
    url: '/getorganization',
    body: params,
    withAuth: true,
  })
